// External Dependencies
import Button, { type ButtonProps } from '@mui/material/Button';
import styled from 'styled-components';

interface Props extends ButtonProps {
  buttonText: string;
}

const StyledButton = styled(Button)({
  margin: 10,
});

// Component Definition
const CustomFormButton = ({
  buttonText,
  className = '',
  ...props
}: Props): JSX.Element => {
  return (
    <StyledButton
      className={className}
      type="submit"
      variant="contained"
      {...props}
    >
      {buttonText}
    </StyledButton>
  );
};

export default CustomFormButton;
